import * as React from 'react';
import { TModalLayout } from './ModalLayout.types';
import { Loader } from 'components';
import './ModalLayout.styles.scss';

export const ModalLayout: TModalLayout = ({
  mainContent,
  footerContent,
  isLoading,
}) => {
  return (
    <div className="modal-layout">
      {isLoading ? (
        <div className="modal-layout__content">
          <Loader />
        </div>
      ) : (
        <div className="modal-layout__content">{mainContent}</div>
      )}

      {footerContent && (
        <div className="modal-layout__footer">{footerContent}</div>
      )}
    </div>
  );
};
